import dynamic from "next/dynamic";

const PriceNoSSR = dynamic(() => import("@/components/atoms/Price/Price"), {
  ssr: false,
});
export default PriceNoSSR;
